/**
 * Makes a non-button element behave like a button for keyboard users.
 *
 * The app renders clickable cards and list rows as <div onClick>, which is
 * invisible to keyboard and screen-reader users: a div is not focusable, gets
 * no Enter/Space activation, and is announced as plain text. The elements are
 * too structurally involved (nested buttons, images, absolute positioning) to
 * become real <button>s without reworking their layout, so they get the
 * button ROLE and the behaviour that role promises.
 *
 * Spread onto the element:
 *   <div {...clickableProps(() => open(id), `Open ${name}`)}>
 *
 * Space is preventDefault'ed because its default action scrolls the page,
 * which would fire the handler and jump the viewport at the same time.
 */
export const clickableProps = (onActivate, label) => ({
  role: 'button',
  tabIndex: 0,
  'aria-label': label,
  onClick: onActivate,
  onKeyDown: (event) => {
    // Ignore activations bubbling up from a nested control that handles its
    // own keys — otherwise Enter on an inner delete button also opens the card.
    if (event.target !== event.currentTarget) return

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onActivate(event)
    }
  }
})

export default clickableProps
